module.exports = __webpack_public_path__ + "static/media/mega_man.63f106d8.png";